<div class="collection-table-container">
    <div class="tabs-container">
        <div class="tabs">
            <h4 class="tab" [ngClass]="{'active': (tab==1)}" (click)="tab=1">Agregar Productos</h4>
            <h4 class="tab" [ngClass]="{'active': (tab==2)}" (click)="tab=2">Mi Colección</h4>
            <h4>{{totalCollectionProducts || 0}} productos en lista</h4>
        </div>
        <div class="actions">
            <button class="button" (click)="fileInput.click()">Importar</button>
            <input #fileInput type="file" accept=".xlsx,.csv" (change)="onFileSelected($event)"
                style="display: none;" />
            <button class="button off" (click)="openExportModal()"   [disabled]="!totalCollectionProducts || totalCollectionProducts === 0">Exportar</button>
        </div>
    </div>
    <div class="filters-container">
        <app-generic-select style="width: 300px;" [items]="categories" (selectionChange)="onCategorySelect($event)"
            (loadMore)="loadMoreCategories()" [placeholder]="'Categoría'" (searchChange)="onCategorySearch($event)"
            (cleared)="clearCategoryFilter()">
        </app-generic-select>
        <app-generic-select style="width: 300px;" [placeholder]="'Marcas'" [items]="brands"
            (loadMore)="loadMoreBrands()" (searchChange)="onBrandSearch($event)"
            (selectionChange)="onBrandSelect($event)" (cleared)="clearBrandFilter()">
        </app-generic-select>
        <app-generic-select style="width: 300px;" [items]="status" (selectionChange)="onStatusSelect($event)"
            (cleared)="clearStatusFilter()" [placeholder]="'Status'">
        </app-generic-select>
    </div>
    <div class="table-container" [ngClass]="{'active': (tab==1)}">
        <ng-container>
            <div class="body-tab">
                <div class="row">
                    <table class="table">
                        <thead>
                            <th>Agregar</th>
                            <th>Imagen</th>
                            <th>Nombre</th>
                            <th>ID</th>
                            <th>SKU</th>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of products">
                                <td>
                                    <ng-container *ngIf="!isProductAdded(item.id); else checked">
                                        <button class="plus-button" (click)="setProduct(item.id)">
                                            <i class="fa fa-plus" aria-hidden="true"></i>
                                        </button>
                                    </ng-container>
                                    <ng-template #checked>
                                        <button class="checked-button" (click)="removeProduct(item.id)">
                                            <i class="fa fa-check" aria-hidden="true"></i>
                                        </button>
                                    </ng-template>
                                </td>
                                <td>
                                    <img *ngIf="item.images?.length && item.images[0]?.url; else noImage2" style="height: 50px;" 
                                         [src]="item.images[0].url" [alt]="item.images[0]?.altText || 'Sin imagen'">
                                    <ng-template #noImage2>
                                      <img style="height: 50px;" src="assets/images/no-product-image.jpeg" alt="Sin imagen">
                                    </ng-template>
                                  </td>
                                <td>
                                    {{item.name}}
                                </td>
                                <td>
                                    {{item.id}}
                                </td>
                                <td>
                                    {{item.sku}}
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </ng-container>
        <div *ngIf="total > 7">
            <app-pagination *ngIf="tab==1" [totalElements]="total" [pageSize]="7"
                (selectPage)="selectPage($event)"></app-pagination>
        </div>
    </div>
    <div class="table-container" [ngClass]="{'active': (tab==2)}">
        <ng-container>
            <div class="body-tab">
                <div class="row">
                    <table class="table">
                        <thead>
                            <th>Agregar</th>
                            <th>Imagen</th>
                            <th>Nombre</th>
                            <th>ID</th>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of collectionProducts">
                                <td>
                                    <ng-container *ngIf="!isProductAdded(item.productId); else checked">
                                        <button class="plus-button" (click)="setProduct(item.productId)">
                                            <i class="fa fa-plus" aria-hidden="true"></i>
                                        </button>
                                    </ng-container>
                                    <ng-template #checked>
                                        <button class="checked-button" (click)="removeProduct(item.productId)">
                                            <i class="fa fa-check" aria-hidden="true"></i>
                                        </button>
                                    </ng-template>
                                </td>
                                <td>
                                    <img *ngIf="item.imageUrl; else noImage1" style="height: 50px;" [src]="item.imageUrl" alt="Imagen producto">
                                    <ng-template #noImage1>
                                      <img style="height: 50px;" src="assets/images/no-product-image.jpeg" alt="Sin imagen">
                                    </ng-template>
                                  </td>
                                <td>
                                    {{item.name}}
                                </td>
                                <td>
                                    {{item.productId}}
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </ng-container>
    </div>

    <div class="export-modal d-block" *ngIf="showExportModal" id="modalExportCollection">
        <article>
            <h1>Exportar colección</h1>

            <p>Selecciona un formato de el que deseas descargar la información: Excel (.xlsx) o CSV</p>
            <div class="radio-container">
                <div class="radio-button">
                    <label>XLS</label>
                    <input type="radio" [(ngModel)]="exportOptions.format" value="xlsx" />
                </div>
                <div class="radio-button">
                    <label>CSV</label>
                    <input type="radio" [(ngModel)]="exportOptions.format" value="csv" />
                </div>
            </div>

            <div class="body-container">
                <p style="margin-top: 16px;"><strong>¿Donde enviamos el archivo?</strong></p>
                <label><input type="checkbox" style="margin-right: 10px;"
                        [(ngModel)]="exportOptions.download" />Descargar en la computadora</label>
                <label><input type="checkbox" style="margin-right: 10px;"
                        [(ngModel)]="exportOptions.sendByEmail" />Exportar por correo</label>

                <div *ngIf="exportOptions.sendByEmail" style="margin-top: 16px;">
                    <label><strong>Destinatarios:</strong></label>
                    <div class="email-chip-container">
                        <span *ngFor="let email of exportOptions.emailList" class="chip">
                            {{ email }} <span class="remove" (click)="removeEmail(email)">×</span>
                        </span>
                        <input type="text" [(ngModel)]="emailInput" (keydown.enter)="addEmail($event)" (blur)="addEmail($event)"

                            (keydown.,)="addEmail($event)" placeholder="ej: uno@mail.com" />
                    </div>
                    <div *ngIf="emailError" class="error-msg">{{ emailError }}</div>
                </div>
            </div>
            <button class="button" (click)="confirmExport()">Aceptar</button>
            <a (click)="closeExportModal()">Cancelar</a>
        </article>
    </div>
</div>